module.exports = __webpack_public_path__ + "media/entities/1005-beea88ab.png";